import React, { PureComponent } from 'react'
import { Col } from 'reactstrap'
import Slider from '../../Slider'

export default class SliderWithScale extends PureComponent {
  render () {
    return (
      <Col md={12}>
        <div className='card__title'>
          <h5>{this.props.question}</h5>
        </div>
        <Slider min={0} max={10} value={3}
          marks={{
            0: '0',
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            10: '10'
          }}
        />
        <br />
      </Col>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/range_sliders/components/SliderWithScale.js